import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { useUser } from '../../components/UserContext';
import { convertTasksIntoTableEntries } from '../../utils/task/task.utils';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const TaskOverview: React.FC = () => {
  const { user, axios, updateContextUser } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: loadedSimpleUsers } = useData('SIMPLEUSERS_ALL', {
    params: { userId: user.id },
    config: { fallbackData: [] },
  });

  const { data: loadedTasks } = useData('TASKS_ALL', {
    params: { userId: user.id },
    config: { fallbackData: [] },
  });

  //Holds the tableRows for tasks
  const rows: TableRow[] = useMemo(
    () => convertTasksIntoTableEntries(loadedTasks, loadedSimpleUsers, navigate),
    [loadedSimpleUsers, loadedTasks, navigate],
  );

  return (
    <>
      <TopBar title={t('pages.tasks.overview.title')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/task/create')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.TASK_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(axios, user, TableKey.TASK_OVERVIEW, updatedHeader).then(
              (updatedUser) => updatedUser && updateContextUser(updatedUser),
            );
          }}
          rows={rows}
          header={
            t('pages.tasks.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
